import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slice/AuthSlice';
import contactUsReducer from '../slice/ContactUsSlice';
import membershipReducer from '../slice/MembershipSlice';
import joinUsReducer from '../slice/JoinUsSlice';
import CountryReducer from '../slice/UtilsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    ContactUsSlice: contactUsReducer,
    membership: membershipReducer,
    JoinUsSlice: joinUsReducer,
    country: CountryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
